import {Line, mixins} from 'vue-chartjs'

export default({
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.data, this.options);
    // $('#tag_machin_learn').click();
    // setTimeout(function(){$('#tag_machin_learn').click();}, 0);
    $('#tag_gdpr').click();
    $('#tag_general_data_protection_regulation').click();
    $('#tag_information_and_communications_technology').click();
  }
})


// WEBPACK FOOTER //
// ./src/components/LineChart.js